import { createSelector } from 'reselect';

const getAppSettingsState = state => state.Settings.app;
const getSettingsState = state => state.Settings;

// eslint-disable-next-line import/prefer-default-export
export const getAppSettings = createSelector(getAppSettingsState, appSettings => appSettings);
export const getSettings = createSelector(getSettingsState, settings => settings);
